<template>

    <div>
        <div class="logoMurprotect">
            <img class="backIcon" src="/images/icn_back.png" @click="$router.push('home')" />
            <img src="/images/logo_murprotect.png"/>
        </div>
        <div v-if="showForm" class="newItem">
            <b-field :label="$t('item.name')" class="newName">
                <b-input v-model="form.name"></b-input>
            </b-field>
            <b-field :label="$t('item.link')" class="newPass">
                <b-input v-model="form.link"></b-input>
            </b-field>
            <button  v-if="form.id" @click="editItem" :disabled="disabled" class="button is-primary">{{ $t('item.edit') }}</button>
            <button  v-else @click="createItem" :disabled="disabled" class="button is-primary">{{ $t('item.create') }}</button>
            <button  @click="showForm=false" class="button is-primary">{{ $t('item.return') }}</button>
        </div>

        <div v-else class="itemList">
            <div class="newButton">
                <a @click="newForm" class="button is-primary">{{ $t('item.create') }}</a>
            </div>
            <div class="item" v-for="item in pdfs">
                <a class="itemImg" target="_blank" :href="item.link">
                    <img src="/images/home/icn_url.png" />
                </a>
                <div class="icons">
                    <a class="itemDelete" @click="confirmDelete(item)"  aria-label="delete">
                      <span class="icon">
                        <i class="fas fa-trash" aria-hidden="true"></i>
                      </span>
                    </a>
                    <a class="itemDelete" @click="editForm(item)"  aria-label="edit">
                      <span class="icon">
                        <i class="fas fa-pen" aria-hidden="true"></i>
                      </span>
                    </a>
                </div>
                <a class="itemName" target="_blank" :href="item.link">
                    <span>{{ item.name }}</span>
                </a>
            </div>
        </div>
    </div>

</template>

<script>
    import firebase from 'firebase/app';
    import {mapState,mapActions} from 'vuex';

    export default {
        components: {},
        name: 'pdfs',
        data() {
            return {
                form: {
                    name: '',
                    link: ''
                },
                showForm: false,
            }
        },
        computed: {

            ...mapState('pdf', {
                pdfs: 'list'
            }),
            disabled: function(){
                return this.form.name.length == 0 || this.form.link.length == 0;
            }

        },
        methods: {
            ...mapActions('pdf', {
                delete: 'deletePdf',
                create: 'createPdf',
                update: 'updatePdf',
            }),

            confirmDelete:function(pdf) {
                this.$dialog.confirm({
                    title:  this.$t('notification.confirmTitle'),
                    message: this.$t('notification.confirmText'),
                    confirmText: this.$t('notification.accept'),
                    cancelText: this.$t('notification.cancel'),
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => this.deleteItem(pdf)
                })
            },

            deleteItem: function(pdf){
                this.delete({id: pdf[".key"]});
            },
            createItem: function(){
                let pdf = this.form;
                this.create({pdf: pdf}).then(() => {
                    this.alertOk();
                }).catch(() =>{
                    this.alertError();
                });
            },
            editItem: function(){
                this.update({data: this.form}).then(() => {
                    this.alertOk();
                }).catch(() =>{
                    this.alertError();
                })
            },
            editForm: function(item){
                this.form.id = item['.key'];
                this.form.name = item.name;
                this.form.link = item.link;
                this.showForm = true;
            },
            newForm: function(){
                this.form.id = '';
                this.form.name = '';
                this.form.link = '';
                this.showForm = true;
            },
            alertOk: function(){
                this.$dialog.alert(this.$t('notification.ok'))
            },
            alertError: function(){
                this.$dialog.alert({
                    title: 'Error',
                    message: this.$t('notification.error'),
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa'
                })
            }
        }

    }
</script>


<style lang="scss" scoped>

</style>
